(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-subscription-buy-box-2]';
  var INITIALIZED_ATTR = 'data-sbb2-initialized';

  function initAllSubscriptionBuyBox2Sections(context) {
    var scope = context || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);

    sections.forEach(function (section) {
      initSubscriptionBuyBox2(section);
    });
  }

  function initSubscriptionBuyBox2(section) {
    if (!section || section.getAttribute(INITIALIZED_ATTR) === 'true') return;

    section.setAttribute(INITIALIZED_ATTR, 'true');
    initForms(section);
  }

  function getConfig(section) {
    var configScript = section.querySelector('[data-sbb2-config]');

    if (!configScript) {
      return {};
    }

    try {
      return JSON.parse(configScript.textContent || '{}');
    } catch (error) {
      console.error('[Subscription Buy Box 2] Invalid config JSON:', error);
      return {};
    }
  }

  function initForms(section) {
    var forms = Array.prototype.slice.call(section.querySelectorAll('[data-sbb2-form]'));

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        handleSubmit(section);
      });
    });
  }

  function handleSubmit(section) {
    var config = getConfig(section);
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-sbb2-button]'));
    var status = section.querySelector('[data-sbb2-status]');
    var originalButtonLabels = buttons.map(function (button) {
      return button.innerHTML;
    });

    if (!config.variantId) {
      setStatus(status, 'Please select a product or enter a variant ID in the section settings.');
      return;
    }

    setStatus(status, '');
    setLoading(buttons, config.loadingText || 'Adding...');

    addOfferToCart(config)
      .then(function () {
        if (config.redirectTarget === 'stay') {
          setStatus(status, config.successText || 'Added to cart.');
          resetButtons(buttons, originalButtonLabels);
        }

        return redirectAfterAdd(config);
      })
      .catch(function (error) {
        console.error('[Subscription Buy Box 2] Add to cart error:', error);
        setStatus(status, config.errorText || 'Something went wrong. Please try again.');
        resetButtons(buttons, originalButtonLabels);
      });
  }

  function addOfferToCart(config) {
    var sequence = Promise.resolve();

    if (config.clearCartBeforeAdd) {
      sequence = sequence.then(clearCart);
    }

    return sequence
      .then(fetchCart)
      .then(function (cart) {
        var mainItem = buildMainItem(config);

        if (!mainItem) {
          throw new Error('No valid main item to add.');
        }

        return addItems([mainItem])
          .then(function () {
            var additionalItems = buildAdditionalItems(config, cart);
            return addOptionalItems(additionalItems);
          });
      })
      .then(function () {
        return updateCartAttributes(config);
      });
  }

  function buildMainItem(config) {
    var item = normalizeCartItem({
      id: config.variantId,
      quantity: config.quantity || 1,
      sellingPlanId: config.sellingPlanId
    });

    if (!item) return null;

    item.properties = {
      _source: config.cartAttributeSource || 'subscription-buy-box-2'
    };

    return item;
  }

  function buildAdditionalItems(config, cart) {
    var cartItems = Array.isArray(cart && cart.items) ? cart.items : [];
    var additionalItems = Array.isArray(config.additionalItems) ? config.additionalItems : [];
    var seenKeys = {};
    var items = [];

    additionalItems.forEach(function (additionalItem) {
      var normalizedItem = normalizeCartItem(additionalItem);

      if (!normalizedItem) return;

      var itemKey = String(normalizedItem.id) + '::' + String(normalizedItem.selling_plan || '');

      if (seenKeys[itemKey]) {
        return;
      }

      if (additionalItem.dedupe && itemAlreadyInCart(cartItems, normalizedItem)) {
        return;
      }

      seenKeys[itemKey] = true;
      items.push(normalizedItem);
    });

    return items;
  }

  function normalizeCartItem(item) {
    if (!item || !item.id) return null;

    var normalized = {
      id: String(item.id),
      quantity: positiveInteger(item.quantity, 1)
    };

    if (item.sellingPlanId) {
      normalized.selling_plan = String(item.sellingPlanId);
    }

    return normalized;
  }

  function positiveInteger(value, fallback) {
    var parsed = parseInt(value, 10);

    if (Number.isNaN(parsed) || parsed < 1) {
      return fallback;
    }

    return parsed;
  }

  function itemAlreadyInCart(cartItems, newItem) {
    return cartItems.some(function (cartItem) {
      var sameVariant = String(cartItem.variant_id) === String(newItem.id);
      var cartSellingPlanId = cartItem.selling_plan_allocation &&
        cartItem.selling_plan_allocation.selling_plan &&
        cartItem.selling_plan_allocation.selling_plan.id;

      var newSellingPlanId = newItem.selling_plan || '';
      var sameSellingPlan = String(cartSellingPlanId || '') === String(newSellingPlanId || '');

      return sameVariant && sameSellingPlan;
    });
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to fetch cart.');
      }

      return response.json();
    });
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to clear cart.');
      }

      return response.json();
    });
  }

  function addItems(items) {
    if (!Array.isArray(items) || items.length === 0) {
      return Promise.resolve();
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: items
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () {
          return {};
        }).then(function (errorData) {
          throw new Error(errorData.description || errorData.message || 'Unable to add item to cart.');
        });
      }

      return response.json();
    });
  }

  function addOptionalItems(items) {
    if (!Array.isArray(items) || items.length === 0) {
      return Promise.resolve();
    }

    var sequence = Promise.resolve();

    items.forEach(function (item) {
      sequence = sequence.then(function () {
        return addItems([item]).catch(function (error) {
          console.warn('[Subscription Buy Box 2] Optional cart item was skipped:', item.id, error);
          return null;
        });
      });
    });

    return sequence;
  }

  function updateCartAttributes(config) {
    if (!config.cartAttributeSource) {
      return Promise.resolve();
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          subscription_buy_box_2_source: config.cartAttributeSource
        }
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to update cart attributes.');
      }

      return response.json();
    });
  }

  function redirectAfterAdd(config) {
    var redirectTarget = config.redirectTarget || 'checkout';

    if (redirectTarget === 'stay') {
      window.dispatchEvent(new CustomEvent('subscription-buy-box-2:added', {
        detail: {
          sectionId: config.sectionId
        }
      }));

      return Promise.resolve();
    }

    var targetPath = redirectTarget === 'cart' ? '/cart' : '/checkout';
    var discountCodes = parseDiscountCodes(config.discountCodes);
    var redirectUrl = buildRedirectUrl(targetPath, discountCodes);

    window.location.assign(redirectUrl);
    return Promise.resolve();
  }

  function parseDiscountCodes(rawCodes) {
    if (!rawCodes || typeof rawCodes !== 'string') {
      return [];
    }

    return rawCodes
      .split(',')
      .map(function (code) {
        return code.trim();
      })
      .filter(Boolean);
  }

  function buildRedirectUrl(redirectPath, discountCodes) {
    if (!Array.isArray(discountCodes) || discountCodes.length === 0) {
      return redirectPath;
    }

    var encodedCodes = discountCodes
      .map(function (code) {
        return encodeURIComponent(code);
      })
      .join(',');

    var separator = redirectPath.indexOf('?') === -1 ? '?' : '&';

    return redirectPath + separator + 'discount=' + encodedCodes;
  }

  function setLoading(buttons, loadingText) {
    buttons.forEach(function (button) {
      button.classList.add('is-loading');
      button.disabled = true;

      if (loadingText) {
        button.innerHTML = '<span class="subscription-buy-box-2__button-primary">' + escapeHtml(loadingText) + '</span>';
      }
    });
  }

  function resetButtons(buttons, originalButtonLabels) {
    buttons.forEach(function (button, index) {
      button.classList.remove('is-loading');
      button.disabled = false;

      if (originalButtonLabels[index]) {
        button.innerHTML = originalButtonLabels[index];
      }
    });
  }

  function setStatus(status, message) {
    if (!status) return;

    status.textContent = message || '';
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllSubscriptionBuyBox2Sections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllSubscriptionBuyBox2Sections(event.target);
  });
})();